exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_wks-ext.js
// module id = 1092
// module chunks = 1